"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportDataComponent = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const downloadWhite_svg_1 = __importDefault(require("../../../assets/icons/downloadWhite.svg"));
const colors_1 = require("../../../assets/styles/colors");
const exportSessionSlice_1 = require("../../../store/exportSessionSlice");
const hooks_1 = require("../../../store/hooks");
const useAutoDismissAlert_1 = require("../../../utils/useAutoDismissAlert");
const Modals_style_1 = require("../../organisms/Modals/Modals.style");
const ModalInput_1 = require("../../organisms/Modals/atoms/ModalInput");
const AlertComponent_1 = require("./AlertComponent");
const S = __importStar(require("./Popups.style"));
const initialExportModalData = {
    email: "",
};
const ExportDataPopup = (props) => {
    return react_1.default.createElement(S.ExportDataSmallPopup, Object.assign({}, props));
};
const ExportDataComponent = ({ button, fixedSessionTypeSelected, sessionsIds, onSubmit, isIconOnly, isSessionList, open, }) => {
    const exportButtonRef = (0, react_1.useRef)(null);
    const focusInputRef = (0, react_1.useRef)(null);
    const [buttonPosition, setButtonPosition] = (0, react_1.useState)({ top: 0, left: 0 });
    const [formState, setFormState] = (0, react_1.useState)(initialExportModalData);
    const [showConfirmation, setShowConfirmation] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)(null);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const NO_SESSIONS = sessionsIds.length === 0;
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormState((prevFormData) => (Object.assign(Object.assign({}, prevFormData), { [name]: value })));
    };
    const handleSubmit = (event, close) => {
        event.preventDefault();
        if (!validateEmail(formState.email)) {
            setErrorMessage(t("exportDataModal.invalidEmailMessage"));
            return;
        }
        dispatch((0, exportSessionSlice_1.exportSession)({ sessionsIds, email: formState.email }));
        onSubmit(formState);
        setFormState(initialExportModalData);
        setShowConfirmation(true);
        close();
    };
    const rect = exportButtonRef.current && exportButtonRef.current.getBoundingClientRect();
    const updateButtonPosition = () => {
        if (rect) {
            setButtonPosition({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX,
            });
        }
    };
    (0, useAutoDismissAlert_1.useAutoDismissAlert)(showConfirmation, setShowConfirmation);
    (0, react_1.useEffect)(() => {
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        return () => {
            window.removeEventListener("resize", updateButtonPosition);
        };
    }, [rect === null || rect === void 0 ? void 0 : rect.top]);
    const calculatePopupLeftPosition = () => {
        if (isSessionList) {
            return `${buttonPosition.left - 185}px`;
        }
        else if (isIconOnly) {
            if (fixedSessionTypeSelected) {
                return `${buttonPosition.left - 60}px`;
            }
            else {
                return `${buttonPosition.left - 30}px`;
            }
        }
        else {
            return `${buttonPosition.left - 2}px`;
        }
    };
    const dynamicArrowStyle = fixedSessionTypeSelected
        ? {}
        : {
            left: `${isIconOnly ? "32%" : "50%"}`,
            borderColor: `transparent transparent ${colors_1.white} transparent`,
            borderWidth: "0 10px 10px 10px",
            borderStyle: "solid",
        };
    return (react_1.default.createElement(S.WrapperButton, { ref: exportButtonRef },
        react_1.default.createElement(ExportDataPopup, { open: open, trigger: button, position: isSessionList ? "left center" : "top center", nested: true, closeOnDocumentClick: true, offsetX: fixedSessionTypeSelected ? 0 : 40, arrowStyle: dynamicArrowStyle }, (close) => (react_1.default.createElement("form", { onSubmit: (formData) => handleSubmit(formData, close) },
            react_1.default.createElement(Modals_style_1.FormWrapper, null,
                react_1.default.createElement(ModalInput_1.ModalInput, { focusInputRef: focusInputRef, value: formState.email, onChange: handleInputChange, name: "email", type: "email" }),
                react_1.default.createElement(Modals_style_1.BlueButton, { type: "submit", "aria-label": t("exportDataModal.exportButton") },
                    t("exportDataModal.exportButton"),
                    react_1.default.createElement("img", { src: downloadWhite_svg_1.default, style: { width: "1.5rem" }, alt: "" }))),
            errorMessage && react_1.default.createElement(ModalInput_1.RedErrorMessage, null, errorMessage)))),
        showConfirmation && (react_1.default.createElement(AlertComponent_1.AlertPopup, { open: showConfirmation, message: t("exportDataModal.confirmationMessage"), top: isSessionList ? buttonPosition.top - 35 : buttonPosition.top - 95, left: calculatePopupLeftPosition() }))));
};
exports.ExportDataComponent = ExportDataComponent;
